export type TypographyType = {
    fontFamily: string,
    fontWeight: number,
    fontSize: string,
    fontStyle?: string,
    lineHeight: string,
    textAlign: string,
    color: string,
    margin?: string,
    letterSpacing?: string,
    transform?: string,
    pointerEvents?: string,
    top?: string,
    left?: string,
    position?: string,
    transition?: string,
    marginTop?: string,
    maxWidth?: string,
    whiteSpace?: string,
}

const h1: TypographyType = {
    fontFamily: 'SF Pro Text',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
    textAlign: 'center',
    color: '#010101',
    margin: '32px 0',
};

const h2: TypographyType = {
    fontFamily: 'SF Pro Text',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '26px',
    textAlign: 'center',
    letterSpacing: '-0.0024em',
    color: '#010101',
    margin: '16px 0 32px',
};

const h3: TypographyType = {
    fontFamily: 'SF Pro Text',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#010101',
    margin: '0 auto',
};

const button: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    lineHeight: '26px',
    fontWeight: 600,
    fontSize: '18px'
};

const choiceButton: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    lineHeight: '24px',
    fontWeight: 400,
    fontSize: '18px',
    letterSpacing: '-0.0024em',
};

const multiChoiceButton: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    lineHeight: '24px',
    fontWeight: 400,
    fontSize: '18px',
    letterSpacing: '-0.0024em',
    textAlign: 'left',
};

const input: Partial<TypographyType> = {

};

const inputStartAdornment: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    lineHeight: '26px',
    fontWeight: 400,
    fontSize: '18px',
    letterSpacing: '-0.0024em',
    color: '#000000',
    margin: '0 0 0 0.75rem',
};

const inputEndAdornment: Partial<TypographyType> = {
    ...inputStartAdornment,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#868C99',
};

const inputLabel: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    fontWeight: 400,
    fontSize: '16px',
    margin: '0px',
    top: '5px',
    color: '#868C99',
    position: 'absolute',
    transform: 'translateY(calc(0.75rem - 1px))',
    transition: 'all 0.2s ease 0s',
    lineHeight: '24px',
    pointerEvents: 'none',
};

const inputLabelActive: Partial<TypographyType> = {
    ...inputLabel,
    top: '8px',
    color: '#868c99',
    fontSize: '.75rem',
    transform: 'translateY(0px)',
    fontWeight: 400,
    lineHeight: '1rem',
    position: 'absolute',
};

const inputLabelError: Partial<TypographyType> = {
    ...inputLabelActive,
    color: '#FF4D2B',
};

const validatedInputError: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#FF4D2B',
    margin: '4px 0 0 16px',
};

const verticalCard: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
    margin: '0 0 12px',
};

const verticalCardDescription: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    maxWidth: '126px',
    margin: '0 0 8px',
};

const tipPage: Partial<TypographyType> = {
    ...h1,
    fontWeight: 400,
    color: '#010101',
    textAlign: 'left',
    margin: 'auto',
    whiteSpace: 'pre-line',
};

const tab: Partial<TypographyType> = {
    fontFamily: 'SF Pro Text',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '-0.08px',
    textAlign: 'center',
};

export const TypographyStyles = {
    h1,
    h2,
    h3,
    button,
    choiceButton,
    multiChoiceButton,
    input,
    inputStartAdornment,
    inputEndAdornment,
    inputLabel,
    inputLabelActive,
    inputLabelError,
    validatedInputError,
    verticalCard,
    verticalCardDescription,
    tipPage,
    tab,
};
